import { type Config } from 'tailwindcss'

export const extendedTheme = {
	gridTemplateRows: {
		'fill-auto': 'minmax(0,1fr) auto',
	},
	colors: {
		border: 'hsl(var(--border))',
		input: {
			DEFAULT: 'hsl(var(--input))',
			invalid: 'hsl(var(--input-invalid))',
		},
		ring: {
			DEFAULT: 'hsl(var(--ring))',
			invalid: 'hsl(var(--foreground-destructive))',
		},
		background: 'hsl(var(--background))',
		foreground: {
			DEFAULT: 'hsl(var(--foreground))',
			destructive: 'hsl(var(--foreground-destructive))',
		},
		primary: {
			DEFAULT: 'hsl(var(--primary))',
			foreground: 'hsl(var(--primary-foreground))',
		},
		secondary: {
			DEFAULT: 'hsl(var(--secondary))',
			foreground: 'hsl(var(--secondary-foreground))',
		},
		destructive: {
			DEFAULT: 'hsl(var(--destructive))',
			foreground: 'hsl(var(--destructive-foreground))',
		},
		muted: {
			DEFAULT: 'hsl(var(--muted))',
			foreground: 'hsl(var(--muted-foreground))',
		},
		accent: {
			DEFAULT: 'hsl(var(--accent))',
			foreground: 'hsl(var(--accent-foreground))',
		},
		popover: {
			DEFAULT: 'hsl(var(--popover))',
			foreground: 'hsl(var(--popover-foreground))',
		},
		card: {
			DEFAULT: 'hsl(var(--card))',
			foreground: 'hsl(var(--card-foreground))',
		},
		sidebar: {
			DEFAULT: 'hsl(var(--sidebar-background))',
			foreground: 'hsl(var(--sidebar-foreground))',
			primary: 'hsl(var(--sidebar-primary))',
			'primary-foreground': 'hsl(var(--sidebar-primary-foreground))',
			accent: 'hsl(var(--sidebar-accent))',
			'accent-foreground': 'hsl(var(--sidebar-accent-foreground))',
			border: 'hsl(var(--sidebar-border))',
			ring: 'hsl(var(--sidebar-ring))',
		},
	},
	borderColor: {
		DEFAULT: 'hsl(var(--border))',
	},
	borderRadius: {
		lg: 'var(--radius)',
		md: 'calc(var(--radius) - 2px)',
		sm: 'calc(var(--radius) - 4px)',
	},
	fontSize: {
		mega: ['5rem', { lineHeight: '5.25rem', fontWeight: '700' }],
		h1: ['3.5rem', { lineHeight: '3.875rem', fontWeight: '700' }],
		h2: ['2.5rem', { lineHeight: '3rem', fontWeight: '700' }],
		h3: ['2rem', { lineHeight: '2.25rem', fontWeight: '700' }],
		h4: ['1.75rem', { lineHeight: '2.25rem', fontWeight: '700' }],
		h5: ['1.5rem', { lineHeight: '2rem', fontWeight: '700' }],
		h6: ['1rem', { lineHeight: '1.25rem', fontWeight: '700' }],
		'body-2xl': ['2rem', { lineHeight: '2.25rem' }],
		'body-xl': ['1.75rem', { lineHeight: '2.25rem' }],
		'body-lg': ['1.5rem', { lineHeight: '2rem' }],
		'body-md': ['1.25rem', { lineHeight: '1.75rem' }],
		'body-sm': ['1rem', { lineHeight: '1.25rem' }],
		'body-xs': ['0.875rem', { lineHeight: '1.125rem' }],
		'body-2xs': ['0.75rem', { lineHeight: '1rem' }],
		caption: ['1.125rem', { lineHeight: '1.5rem', fontWeight: '600' }],
		button: ['0.75rem', { lineHeight: '1rem', fontWeight: '700' }],
	},
	keyframes: {
		'caret-blink': {
			'0%,70%,100%': { opacity: '1' },
			'20%,50%': { opacity: '0' },
		},
		'accordion-down': {
			from: { height: '0' },
			to: { height: 'var(--radix-accordion-content-height)' },
		},
		'accordion-up': {
			from: { height: 'var(--radix-accordion-content-height)' },
			to: { height: '0' },
		},
	},
	animation: {
		'caret-blink': 'caret-blink 1.25s ease-out infinite',
		'accordion-down': 'accordion-down 0.2s ease-out',
		'accordion-up': 'accordion-up 0.2s ease-out',
	},
} satisfies Config['theme']
